import Banner from "../Allcomponent/Banner"

import Watches from "../Allcomponent/watches"
import Cards from "../Allcomponent/cards"
function Watchess(){
    return(
        <>
        <Banner/>
         <Cards/>
        <Watches/>
        </>
    )
}
export default Watchess